import { scheduleResourcesSelector } from "./scheduleResourcesSelector";
import { RootState } from "../../../store";
import { ResourceType } from "../../../../services/cloudchipr.api";

export const scheduleResourcesByResourceTypeEmsSelector = (
  state: RootState,
  resourceType: ResourceType,
  scheduleId: string,
): number => {
  const response = scheduleResourcesSelector(state, resourceType, scheduleId);

  return response?.data?.estimated_monthly_waste ?? 0;
};
